import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        {/* <p>
          Edit <code>src/App.js</code> and save to reload.
        </p> */}
        <a
          className="App-link"
          href="https://ravesio.my.id"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ravesio System Integrations
        </a>
      </header>
    </div>
  );
}

export default App;
